(function ($, drupalSettings) {

  "use strict";

  Drupal.behaviors.treston_cart = {
    init: false,
    attach: function(context, settings) {
      var infoString = Drupal.t('Your Enquiry Basket is empty. You can choose products for your request by clicking the “Enquiry Basket” icon next to the products.');
      if(!this.init) {
        new jBox('Tooltip', {
          attach: '.cart-block--summary__icon.empty',
          trigger: 'mouseenter',
          content: infoString,
          position: {
            x: 'center',
            y: 'bottom'
          },
          outside: 'y',
          maxWidth: 396
        });
        this.init = true;
      }
    }
  }

})(jQuery, drupalSettings);
